import axios from 'axios';
import { API_CONFIG, API_URL } from '../constants/apiConstants';
import { TOKEN_KEYS } from '../constants/tokenConstants';
import { logout, store } from 'data';

const client = axios.create({
  baseURL: API_URL,
  timeout: API_CONFIG.TIMEOUT,
});

client.interceptors.request.use(
  (config) => {
    if (!config.url?.includes('login')) {
      const authToken = localStorage.getItem(TOKEN_KEYS.ACCESS_TOKEN);
      if (authToken) {
        config.headers['Authorization'] = `Bearer ${authToken}`;
      }
    }
    return config;
  },
  (err) => Promise.reject(err),
);

client.interceptors.response.use(
  (res) => {
    if (res.config.url?.includes('login')) {
      const token = res.data.token;
      if (token) {
        localStorage.setItem(TOKEN_KEYS.ACCESS_TOKEN, token);
        client.defaults.headers.common.Authorization = `Bearer ${token}`;
      }
    }
    return res;
  },
  async (error) => {
    const originalRequest = error.config;
    const isLoginRequest = originalRequest?.url?.includes('login');
    if (error.response?.status === 401 && !isLoginRequest && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        await client.get('/users/refresh/');
        return client(originalRequest);
      } catch (refreshError) {
        console.debug(refreshError);
        store.dispatch(logout());
        localStorage.removeItem(TOKEN_KEYS.ACCESS_TOKEN);
        window.location.replace('/login');
      }
    }

    if (error.response?.status === 403) {
      console.warn('Access forbidden.');
    }

    return Promise.reject(error);
  },
);

export default client;
